import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { PostJSON } from "../lib/fetchers.js";
import { OutsideClickWatcher } from "../lib/outside-clicks.js";

/**
 * Like Button, with popout to choose a like or prompt for login
 * Expects the entity property to be a vwPost
 */
export class PostLikeButton extends UnshadowedElement {
    static elementName() { return "post-like-button" }

    static properties = {
        entity: { type: Object },

        showingPopout: { state: true, type: Boolean },
        error: { state: true, type: Boolean },
    };

    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("postLikeChange", e => this.ExternalLikeChange(e));
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("postLikeChange", e => this.ExternalLikeChange(e));
    }

    /** When likes are modified internally or externally, update the array */
    ExternalLikeChange(e) {
        if (!this.entity) return;
        if (e && this.entity && this.entity.Post && e.detail.postId === this.entity.Post.Id) {
            this.entity.PostLikes = e.detail.likes;
            this.requestUpdate();
        }
    }

    async Like(typeId) {
        try {
            const like = await PostJSON("/trains/" + window.CurrentTrain.Id + "/updates/" + this.entity.Post.Id + "/likes", { typeId });
            if (!this.entity.PostLikes || !this.entity.PostLikes.length) this.entity.PostLikes = [];
            this.entity.PostLikes.push(like);
        } catch {
            this.error = true;
        }
        this.showingPopout = false;
        window.dispatchEvent(new CustomEvent("postLikeChange", { detail: { postId: this.entity.Post.Id, likes: this.entity.PostLikes }}));
    }

    async Unlike() {
        if (this.entity.PostLikes && this.entity.PostLikes.length) {
            const myLikeIdx = this.entity.PostLikes.findIndex(item => item.Author.Id === window.UserHash);
            if (myLikeIdx >= 0) {
                try {
                    await PostJSON("/trains/" + window.CurrentTrain.Id + "/updates/" + this.entity.Post.Id + "/likes/" + this.entity.PostLikes[myLikeIdx].Id + "/delete");
                    this.entity.PostLikes.splice(myLikeIdx, 1);
                } catch {
                    this.error = true;
                }
            }
        }
        window.dispatchEvent(new CustomEvent("postLikeChange", { detail: { postId: this.entity.Post.Id, likes: this.entity.PostLikes } }));
    }

    render() {
        if (!this.entity) return;
        if (this.error) return html`<button disabled class="button button-outline button-rectangle"><svg role="img" width="24" height="24"><use href="#warning-triangle" /></svg> Error</button>`;
        let myLike = null;
        if (this.entity.PostLikes && this.entity.PostLikes.length) {
            myLike = this.entity.PostLikes.find(item => item.Author.Id === window.UserHash);
        }
        // Preserve query params and hash for return URL
        const relativeUrl = window.location.pathname + window.location.search + window.location.hash;
        return html`
            ${myLike ? html`
                <button class="button button-outline button-rectangle" @click=${this.Unlike}><svg role="img" width="24" height="24"><use href="#${LikeSvgSmall[myLike.TypeId]}" /></svg> Liked</button>
            ` : html`
                <button class="button button-outline button-rectangle" @click=${() => this.showingPopout = true}><svg role="img" width="24" height="24"><use href="#add-reaction-blue" /></svg> Like</button>
            `}
            ${this.showingPopout ? html`
                <div id="popoutLikeOptions" class="context-menu add-reactions-menu animate">
                    ${window.UserHash ? html`
                    <div class="reaction-buttons">
                        <button @click=${() => this.Like(0)}><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[0]}" /></svg></button>
                        <button @click=${() => this.Like(2)}><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[2]}" /></svg></button>
                        <button @click=${() => this.Like(3)}><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[3]}" /></svg></button>
                        <button @click=${() => this.Like(1)}><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[1]}" /></svg></button>
                    ` : html`
                        <p><a href="/users/sign_in?ReturnUrl=${encodeURIComponent(relativeUrl)}" class="underline strong">Sign in</a> to add your reaction.</p>
                        <div class="reaction-buttons disabled">
                            <div><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[0]}" /></svg></div>
                            <div><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[1]}" /></svg></div>
                            <div><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[2]}" /></svg></div>
                            <div><svg role="img" width="50" height="50"><use href="#${LikeSvgLarge[3]}" /></svg></div>
                        </div>
                    `}
                </div>
            ` : null}
        `;
    }

    clickOutsideHandlerId = null;

    // Clean up after DOM elements are created
    updated() {
        if (this.showingPopout) {
            const likeOptions = document.getElementById("popoutLikeOptions");
            if (likeOptions) {
                // Click event propagates upwards, so window.click fires after the listener is created. Have to ignore the first immediate click event.
                setTimeout(() => { this.clickOutsideHandlerId = OutsideClickWatcher.AddListener(likeOptions, () => { this.showingPopout = false; }); }, 100);
            }
        } else {
            // If we previously registered a click outside handler, remove it
            if (this.clickOutsideHandlerId) {
                OutsideClickWatcher.RemoveListener(this.clickOutsideHandlerId);
                this.clickOutsideHandlerId = null;
            }
        }
    }
}

export const LikeSvgSmall = {
    0: "reaction-hug-sm",
    1: "reaction-heart-sm",
    2: "reaction-like-sm",
    3: "reaction-smile-sm",
}
export const LikeSvgLarge = {
    0: "reaction-hug-lg",
    1: "reaction-heart-lg",
    2: "reaction-like-lg",
    3: "reaction-smile-lg",
}